import { render, staticRenderFns } from "./BasesEmails.vue?vue&type=template&id=22c9c441"
import script from "./BasesEmails.vue?vue&type=script&lang=js"
export * from "./BasesEmails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports